var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKeepswap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1644_18171)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.46128,
    y: 6.86818,
    width: 10.5,
    height: 16.5,
    rx: 3.25,
    transform: "rotate(-20 1.46128 6.86818)",
    fill: "#F5E7FF",
    stroke: "#9610FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4209,
    y: 1.96128,
    width: 10.5,
    height: 16.5,
    rx: 3.25,
    transform: "rotate(20 13.4209 1.96128)",
    fill: "#F5E7FF",
    stroke: "#9610FF",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1644_18171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKeepswap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/keepswap.4f6325c403615d362ff9d1c9fd5f0fb7.svg";